import React from 'react';
import { useTranslation } from 'react-i18next';

import { alpha, useTheme } from '@mui/material/styles';
import {
  Box,
  Table,
  Paper,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
} from '@mui/material';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

function CSVUploadInstructions() {
  const { t } = useTranslation();
  const { isSmallScreen } = useResponsiveScreen();
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box
      sx={{
        bgcolor: isDark ? alpha(theme.palette.success.main, 0.08) : '#c4ecbc',
        color: isDark ? 'success.main' : '#41aa35',
        border: isDark ? '1.5px solid' : 'none',
        borderColor: 'success.main',
        p: 2,
        borderRadius: 4,
        mb: 2,
        boxShadow: isDark ? 'none' : 3,
      }}
    >
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          marginLeft: '20px',
          fontSize: isSmallScreen ? '0.8rem' : '1rem',
          color: isDark ? 'success.main' : 'inherit',
        }}
      >
        {t('inputs.CSV.titleText')}
      </Typography>
      <Typography
        sx={{
          marginLeft: '40px',
          fontSize: isSmallScreen ? '0.8rem' : '1rem',
          color: 'text.primary',
        }}
        variant="body1"
      >
        {t('inputs.CSV.tableDescriptionText')}
      </Typography>

      <TableContainer
        size="small"
        component={Paper}
        sx={{
          marginTop: '20px',
          // Styles the horizontal table scrollbar for dark mode
          '&::-webkit-scrollbar': {
            width: '6px',
            height: '6px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: isDark ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.15)',
            borderRadius: '10px',
            '&:hover': {
              backgroundColor: isDark ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.3)',
            },
          },
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  fontSize: isSmallScreen ? '0.7rem' : '1rem',
                }}
              >
                Username
              </TableCell>
              <TableCell
                sx={{
                  fontSize: isSmallScreen ? '0.7rem' : '1rem',
                }}
              >
                Email
              </TableCell>
              <TableCell
                sx={{
                  fontSize: isSmallScreen ? '0.7rem' : '1rem',
                }}
              >
                AppUserRole
              </TableCell>
              <TableCell
                sx={{
                  fontSize: isSmallScreen ? '0.7rem' : '1rem',
                }}
              >
                GivenName
              </TableCell>
              <TableCell
                sx={{
                  fontSize: isSmallScreen ? '0.7rem' : '1rem',
                }}
              >
                FamilyName
              </TableCell>
              <TableCell
                sx={{
                  fontSize: isSmallScreen ? '0.7rem' : '1rem',
                }}
              >
                PhoneNumber
              </TableCell>
              <TableCell
                sx={{
                  fontSize: isSmallScreen ? '0.7rem' : '1rem',
                }}
              >
                IsAvailable
              </TableCell>
              <TableCell
                sx={{
                  fontSize: isSmallScreen ? '0.7rem' : '1rem',
                }}
              >
                DepartmentIds
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell
                sx={{
                  fontSize: isSmallScreen ? '0.7rem' : '1rem',
                }}
              >
                agent1
              </TableCell>
              <TableCell
                sx={{
                  fontSize: isSmallScreen ? '0.7rem' : '1rem',
                }}
              >
                agent1@example.com
              </TableCell>
              <TableCell
                sx={{
                  fontSize: isSmallScreen ? '0.7rem' : '1rem',
                }}
              >
                ROLE_TICKETMANAGER
              </TableCell>
              <TableCell
                sx={{
                  fontSize: isSmallScreen ? '0.7rem' : '1rem',
                }}
              >
                John
              </TableCell>
              <TableCell
                sx={{
                  fontSize: isSmallScreen ? '0.7rem' : '1rem',
                }}
              >
                Doe
              </TableCell>
              <TableCell
                sx={{
                  fontSize: isSmallScreen ? '0.7rem' : '1rem',
                }}
              >
                12345678
              </TableCell>
              <TableCell
                sx={{
                  fontSize: isSmallScreen ? '0.7rem' : '1rem',
                }}
              >
                TRUE
              </TableCell>
              <TableCell
                sx={{
                  fontSize: isSmallScreen ? '0.7rem' : '1rem',
                }}
              >
                1, 2
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default CSVUploadInstructions;
